/* Copyright (C) 2016 NooBaa */

import template from './unsupported-form.html';

export default {
    template: template
};
